import { Box, Button, FlexBox, Text } from '@dixa/lib-shared-habla';
import { useCopyToClipboard } from 'react-use';

import { DocumentationLink } from '../documentationLink/documentationLink';

interface MobileSetupProps {
  messengerToken: string;
}

export function MobileSetup({ messengerToken }: MobileSetupProps): JSX.Element {
  const [_, copyToClipboard] = useCopyToClipboard();

  return (
    <FlexBox flexDirection="column" gap="300">
      <Text.Paragraph variant="3" subdued>
        Messenger token
      </Text.Paragraph>
      <pre>{messengerToken}</pre>
      <DocumentationLink />
      <Box>
        <Button icon="copy" onClick={() => copyToClipboard(messengerToken)}>
          Copy Messenger Token
        </Button>
      </Box>
    </FlexBox>
  );
}
